import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import moment from 'moment'
import { EventsFiltersContext } from '../../../context/EventsFiltersContext'
import { ChartLineThemes } from '../../../components/charts/types/ChartLine'
import { FilterEvents } from '../../../types/FilterEvents'
import { formatNumber, formatDateCard } from '../../../utils/Helpers'
import ChartColumnStacked from '../../../components/charts/ChartColumnStacked'
import ChartLineSkeleton from '../../../components/skeletons/ChartColumnSkeleton'
import { GET_DAILY_HTTP_CODES } from '../../../queries/events'
import { defaultDateRange, defaultFormatTimeZone } from '../../../utils/consts'

type HttpCodesBucket = {
  key: string
  doc_count: number
}

type HttpCodesOverTime = {
  key_as_string: string,
  key: number,
  doc_count: number,
  httpCodes: {
    buckets: [HttpCodesBucket]
  }
}

type Series = {
  name: string
  data: number[]
}

const DailyHttpCodes = (): JSX.Element => {
  const { filters } = useContext(EventsFiltersContext)
  const categories: Array<string> = []
  const series: Array<Series> = []

  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_DAILY_HTTP_CODES, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    let date: FilterEvents['date'] = { ...defaultDateRange }

    if (filters.date) {
      date = {
        ...filters.date,
        ...defaultFormatTimeZone
      }
    }

    getData({
      variables: { filters: { ...filters, date } }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartLineSkeleton />
  if (loading || !data) return <ChartLineSkeleton />
  if (error) return <p>Error!</p>
  if (!data.aggregation.aggregations.httpCodesOverTime) return <p>No data found</p>

  const { buckets } = data.aggregation.aggregations.httpCodesOverTime

  buckets.map((bucket: HttpCodesOverTime) => {
    bucket.httpCodes.buckets.map((httpCodeBucket: HttpCodesBucket) => {
      const filteredSerie = series.filter(serie => serie.name === httpCodeBucket.key)
      if (filteredSerie && filteredSerie[0]) {
        filteredSerie[0].data.push(httpCodeBucket.doc_count)
      } else {
        series.push({ name: httpCodeBucket.key, data: [httpCodeBucket.doc_count] })
      }
    })
  })

  buckets.map((bucket: HttpCodesOverTime) => {
    categories.push(bucket.key_as_string)
  })

  const options = {
    chart: {
      id: 'orders-total-history'
    },
    xaxis: {
      categories,
      type: 'datetime',
      labels: {
        formatter: (value: Date) => {
          return moment(value).format('DD-MM-YYYY')
        }
      }
    },
    yaxis: {
      categories,
      labels: {
        formatter: (value: number) => {
          return formatNumber(value)
        }
      }
    },
    tooltip: {
      y: {
        formatter: (value: number) => {
          return formatNumber(value, 2, true)
        }
      }
    }
  }

  return <Paper elevation={2}>
    <Typography paragraph style={{ paddingLeft: '20px', paddingTop: '20px' }}>Códigos HTTP ({formatDateCard(filters.date?.initialDate, filters.date?.finalDate)})</Typography>
    <ChartColumnStacked options={options} series={series} theme={ChartLineThemes.grey} height={320} />
  </Paper>
}

export default DailyHttpCodes
